import { mapPaginated } from '@sb/feathers-types';
import type { USBDriveData } from '@sb/feathers-types';

import { getService } from '../utils';

/**
 * Returns all detected USB drives.
 * `selectField` controls which field is populated ('dockerImages' or 'backups'); it does not filter drives.
 *
 * Examples:
 * - getUSBDrives('dockerImages') → returns all USB drives; each item has `dockerImages` populated and `backups` empty
 * - getUSBDrives('backups') → returns all USB drives; each item has `backups` populated and `dockerImages` empty
 */
export const getUSBDrives = async (
  selectField: keyof Pick<USBDriveData, 'dockerImages' | 'backups'>,
): Promise<USBDriveData[]> => {
  const usb = getService('usb')();

  const result = await usb.find({ query: { $select: selectField } });

  return mapPaginated(result, (r) => r);
};
